var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.34664 5H21.2962C21.4878 5 21.6429 5.2085 21.6429 5.46609V18.1053C21.6429 18.3629 21.4878 18.5714 21.2962 18.5714H7.35372H6.03788H3.56057H2.34664C2.15506 18.5714 2 18.3629 2 18.1053V5.46609C2 5.2085 2.15506 5 2.34664 5ZM9.9702 17.6392H20.6108V5.93219H3.0321V17.6392H3.80548V16.8991C3.80548 16.5563 4.11408 16.2776 4.49355 16.2776H7.84098C8.22045 16.2776 8.52905 16.5563 8.52905 16.8991V17.6392H9.9702Z",
    fill: "#767676"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.12501 14.5922C6.12501 14.5922 6.44011 10.8141 9.21582 10.3266C11.6273 9.90313 12.5938 12.4874 14.9274 12.5244C17.3878 12.5635 18.9248 8.95133 18.9248 8.95133",
    stroke: "#767676",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteboard);
export default __webpack_public_path__ + "static/media/Whiteboard.558cd18ebf18a6d1858c0d26cb29b28b.svg";
export { ForwardRef as ReactComponent };